module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-21.b1f8e726.svg";